import * as api from "./client";

export type Ranking = {
  id: string;
  wpRankingId: number | null;
  companyId: number | null;
  companyName: string | null;
  companySlug: string | null;
  wpPracticeAreaId: number | null;
  wpPracticeAreaName: string | null;
  wpCountrySlug: string | null;
  wpCountryName: string | null;
  rankingTier: number | null;
  rankingType: string | null;
  rankingTableName: string | null;
  site: string | null;
  hasAccoladeCssLtq: boolean;
  hasAccoladeCssVbe: boolean;
  hasAccoladeCssSik: boolean;
  hasAccoladeNps: boolean;
  isGlobal: boolean;
  hasUpdatedContent: boolean;
};

export type RankingsListResponse = {
  rankings: Ranking[];
  pagination: {
    total: number;
    limit: number;
    offset: number;
    hasMore: boolean;
  };
};

export type RankingsQuery = {
  search?: string;
  site?: string;
  companyId?: number;
  countrySlug?: string;
  limit?: number;
  offset?: number;
};

function buildQueryString(params: RankingsQuery): string {
  const searchParams = new URLSearchParams();
  if (params.search) searchParams.set("search", params.search);
  if (params.site) searchParams.set("site", params.site);
  if (params.companyId !== undefined) searchParams.set("companyId", params.companyId.toString());
  if (params.countrySlug) searchParams.set("countrySlug", params.countrySlug);
  if (params.limit !== undefined) searchParams.set("limit", params.limit.toString());
  if (params.offset !== undefined) searchParams.set("offset", params.offset.toString());
  const query = searchParams.toString();
  return query ? `?${query}` : "";
}

export const rankings = {
  getAll: async (params: RankingsQuery = {}): Promise<RankingsListResponse> => {
    const queryString = buildQueryString(params);
    return api.get<RankingsListResponse>(`/v1/data-marts/rankings${queryString}`);
  },
};
